import React, { useState } from "react";
import { SendHotelBookingNotifications } from "../../Services/HotelSearchApi";

const HotelEmailTicket = ({ referenceNo, traceID }) => {
  const [emailAddress, setEmailAddress] = useState("");
  const [emailPricing, setEmailPricing] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClickEmail = async () => {
    // Basic validation
    if (!emailAddress) {
      alert("Please enter email address");
      return;
    }

    // if (!emailPricing) {
    //   alert("Please select a pricing option");
    //   return;
    // }

    try {
      setLoading(true);

      const payload = {
        referenceNo: referenceNo,
        communicationType: "Email",
        trackId: traceID,
        communicationOn: emailAddress,
        pricingOption: "string",
        clientCode: "BerryJourneys",
      };

      //console.log("SendHotelBookingNotifications", payload);
      const response = await SendHotelBookingNotifications(payload);

      if (
        response === "Mail triggered successfully" ||
        response.success === true
      ) {
        alert(`Email sent successfully on ${emailAddress}`);
        setEmailAddress("");
        setEmailPricing("");
      } else {
        alert(response || "Failed to send email.");
      }
    } catch (error) {
      console.error("Email Error:", error);
      alert("Something went wrong while sending email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="form_row">
          <label className="required fw-bold mb-2">Enter Email Address</label>
          <input
            type="email"
            className="form-control"
            placeholder="Enter Email Address..."
            value={emailAddress}
            onChange={(e) => setEmailAddress(e.target.value)}
          />
        </div>
      </div>

      {/* <div className="col-md-12 mt-4">
        <p className="fw-bold mb-2">Select Desired Pricing Option</p>

        <div className="d-flex flex-wrap border rounded p-2">
          <div className="form-check me-4 my-2">
            <input
              type="radio"
              className="form-check-input"
              id="emailRadio1"
              name="emailPricing"
              value="withPrice"
              checked={emailPricing === "withPrice"}
              onChange={(e) => setEmailPricing(e.target.value)}
            />
            <label className="form-check-label" htmlFor="emailRadio1">
              With Price
            </label>
          </div>

          <div className="form-check me-4 my-2">
            <input
              type="radio"
              className="form-check-input"
              id="emailRadio2"
              name="emailPricing"
              value="withoutPrice"
              checked={emailPricing === "withoutPrice"}
              onChange={(e) => setEmailPricing(e.target.value)}
            />
            <label className="form-check-label" htmlFor="emailRadio2">
              Without Price
            </label>
          </div>

          <div className="form-check my-2">
            <input
              type="radio"
              className="form-check-input"
              id="emailRadio3"
              name="emailPricing"
              value="hideMarkup"
              checked={emailPricing === "hideMarkup"}
              onChange={(e) => setEmailPricing(e.target.value)}
            />
            <label className="form-check-label" htmlFor="emailRadio3">
              Hide Markup
            </label>
          </div>
        </div>
      </div> */}

      <div className="col-md-12 text-end mt-4">
        <div className="modal-footer border-0 p-0">
          <button
            type="button"
            className="btn btn-primary px-5"
            onClick={handleClickEmail}
            disabled={loading}
            style={{ background: "#110942" }}
          >
            {loading ? "Sending..." : "Send Email"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HotelEmailTicket;
